import React from 'react';
import classNames from 'classnames';
import InfoCircleOutlined from '@ant-design/icons/lib/icons/InfoCircleOutlined';
import { Tooltip } from 'antd';
import { useAppSelector } from '../../../../store/hooks';
import { fullStockSummaryDataSelector } from '../../../../store/selectors/reportsSelectors';
import './FullStockSummary.scss';

const TOOLTIP_TEXT = 'Total cost value for allocated, picked and collected parts';

const FullStockSummary: React.FC = () => {
  const summary = useAppSelector(fullStockSummaryDataSelector);
  return (
    <section className="summary-row">
      <h2 className="summary-row__title">Summary</h2>
      <div className="summary-row__sections">
        {summary.map((el, i) => (
          <div key={i} className={classNames('summary-row__data', { 'summary-row__data--bold': el.label === 'Total cost' })}>
            <span>
              {el.label}
              {el.label === 'WIP cost' && <Tooltip title={TOOLTIP_TEXT} overlayClassName="fullStockSummary__tooltip">
                <InfoCircleOutlined className="fullStockSummary__icon" />
              </Tooltip>}
            </span>
            <span>{el.value}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FullStockSummary;
